import * as z from "zod";

export const ASK_REDO_CAPABILITY_CTA_LABELS = [
  "Open settings",
  "Continue setup",
] as const;

export const AskRedoCapabilityActionTargetSchema = z.discriminatedUnion(
  "type",
  [
    z
      .object({
        type: z.literal("settings_group"),
        groupId: z.string(),
        settingId: z.string().optional(),
      })
      .strict(),
    z.object({ type: z.literal("support_setup") }).strict(),
  ],
);

export type AskRedoCapabilityActionTarget = z.infer<
  typeof AskRedoCapabilityActionTargetSchema
>;

export const AskRedoCapabilityLinkCardSchema = z
  .object({
    type: z.literal("link_card"),
    capabilityId: z.string(),
    title: z.string(),
    description: z.string(),
    action: z
      .object({
        target: AskRedoCapabilityActionTargetSchema,
        label: z.enum(ASK_REDO_CAPABILITY_CTA_LABELS),
      })
      .strict(),
  })
  .strict();

export type AskRedoCapabilityLinkCard = z.infer<
  typeof AskRedoCapabilityLinkCardSchema
>;

export const AskRedoCapabilityPresentationSchema = z.discriminatedUnion(
  "type",
  [AskRedoCapabilityLinkCardSchema],
);

export type AskRedoCapabilityPresentation = z.infer<
  typeof AskRedoCapabilityPresentationSchema
>;

export const AskRedoCapabilityBlockOutputSchema = z
  .object({ capabilityBlock: AskRedoCapabilityPresentationSchema })
  .strict();

export type AskRedoCapabilityBlockOutput = z.infer<
  typeof AskRedoCapabilityBlockOutputSchema
>;
